export function computeScore(scoreboardCoursesGroupedByModule) {
  let completedCoursesByCategory = new Map();

  for (const [_, courses] of scoreboardCoursesGroupedByModule) {
    for (const course of courses) {
      const currentCount = completedCoursesByCategory.get(course.category) || 0;

      if (course.enrollmentDate && course.completionDate) {
        completedCoursesByCategory.set(course.category, currentCount + 1);
      } else {
        completedCoursesByCategory.set(course.category, currentCount);
      }
    }
  }

  const requiredMap = new Map();

  for (const [_, courses] of scoreboardCoursesGroupedByModule) {
    for (const course of courses) {
      const currentRequired = requiredMap.get(course.category) || 0;

      if (course.courseName) {
        requiredMap.set(course.category, currentRequired + 1);
      }
    }
  }

  let score = 0;

  for (const [category, completedCourses] of completedCoursesByCategory) {
    const requiredCourses = requiredMap.get(category) || 0;

    if (requiredCourses === completedCourses && requiredCourses > 0) {
      score += 100;
    }
  }

  return score;
}

export function computeLevel(score) {
  let currentLevel = "Foundation",
    nextLevel = "AI Aware";

  if (score === 100) {
    currentLevel = "Foundation";
    nextLevel = "AI Aware";
  } else if (score === 200) {
    currentLevel = "AI Aware";
    nextLevel = "AI Practitioner";
  } else if (score === 300) {
    currentLevel = "AI Practitioner";
    nextLevel = "AI Strategist";
  } else if (score === 400) {
    currentLevel = "AI Strategist";
    nextLevel = "AI Native";
  } else if (score === 500) {
    currentLevel = "AI Native";
    nextLevel = "";
  }

  return { currentLevel, nextLevel };
}

export function computePoints(scoreboardCoursesGroupedByModule) {
  let completedPoints = new Map();

  for (const [learningModule, courses] of scoreboardCoursesGroupedByModule) {
    let allCompleted = true;

    // check if any learningModule has an incomplete course
    for (const course of courses) {
      if (
        course.courseName &&
        (!course.enrollmentDate || !course.completionDate)
      ) {
        allCompleted = false;
        break;
      }
    }

    // ✅ Assign 100 ONLY if all completed, else 0
    if (allCompleted && courses.length > 0) {
      completedPoints.set(learningModule, 100);
    } else {
      completedPoints.set(learningModule, 0);
    }
  }

  return completedPoints;
}
